import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { useSearchField } from '@react-aria/searchfield';
import { mergeProps } from '@react-aria/utils';
import { useSearchFieldState } from '@react-stately/searchfield';
import { useInputFormField } from '../../../../FormField/components/Input/hooks/useInputFormField.js';
import { useSelectAutocompleteContext } from '../../SelectAutocomplete/hooks/useSelectAutocompleteContext.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useSelectSearchField = function useSelectSearchField(props) {
  var id = props.id,
    ariaLabel = props['aria-label'];
  var _useSelectAutocomplet = useSelectAutocompleteContext(),
    inputRef = _useSelectAutocomplet.inputRef,
    textFieldProps = _useSelectAutocomplet.textFieldProps;
  var state = useSearchFieldState(_objectSpread({}, textFieldProps));
  var _useSearchField = useSearchField(_objectSpread(_objectSpread({}, textFieldProps), {}, {
      'aria-label': ariaLabel
    }), state, inputRef !== null && inputRef !== void 0 ? inputRef : {
      current: null
    }),
    inputProps = _useSearchField.inputProps;
  var _useInputFormField = useInputFormField({
      rootProps: {
        id: id
      },
      inputProps: {
        type: 'search',
        placeholder: 'Search'
      }
    }),
    rootProps = _useInputFormField.rootProps,
    formFieldInputProps = _useInputFormField.inputProps,
    controlContainerProps = _useInputFormField.controlContainerProps;
  return {
    inputRef: inputRef,
    rootProps: rootProps,
    inputProps: mergeProps(formFieldInputProps, inputProps),
    controlContainerProps: controlContainerProps
  };
};

export { useSelectSearchField };
//# sourceMappingURL=useSelectSearchField.js.map
